<div class="details-view">

  <div class="details-view-head">

    @if (dataLoaded) {
    <div class="details-view-row-top">
      <div alternativeBackRoute="/trial" backBtn class="back-btn"></div>

      <div class="details-view-trial-info">
        <span class="badge-reference-wrap">
          <app-badge-trial [state]="trial.state"></app-badge-trial>
          <span class="field-value details-view-trial-reference">{{ trial.label }}</span>
          <span class="field-value details-view-trial-visits">{{ trial.visitCount }} Visits</span>
        </span>

        <a *ngIf="trial.sharepointLink" class="link" [href]="formatUrl(trial.sharepointLink)" target="_blank">
          Sharepoint <i class="fa-solid fa-arrow-up-right-from-square"></i>
        </a>
      </div>

      <div class="btn-wrap flex-row gap-x-2">
        <app-button text="Export" variant="info" (clicked)="onShowTripExportModal()"
          [visible]="authService.hasPermission(Permissions.TrialExportTripData)">
        </app-button>

        <app-button text="Edit" href="/trial/{{ trial.id }}/edit"
          [visible]="authService.hasPermission(Permissions.TrialEditPublic)">
        </app-button>
      </div>
    </div>

    <div class="details-view-row-desc" style="display: flex; justify-content: space-between; align-items: center;">
      <p class="added-by">
        Added by {{ trial.createdBy }} on {{ trial.created | date: 'd MMM yyyy' }}
        at {{ trial.created | date: 'h:mm aaa' }}
      </p>

      @if (trial.apiEnabled) {
      <app-badge [badgeStyle]="BadgeStyle.Primary" [size]="BadgeSize.Sm">API Enabled</app-badge>
      }
    </div>
    } @else {
    <div class="details-view-head-loader">
      <div class="details-view-row-top">
        <div alternativeBackRoute="/trial" backBtn class="back-btn"></div>

        <div class="details-view-trial-info">
          <span class="badge-reference-wrap">
            <ngx-skeleton-loader class="badge"
              style="width:58px; height:36px; float:left; margin-right:10px; display:block; border-radius:6px;">
            </ngx-skeleton-loader>

            <span class="details-view-trial-reference">
              <ngx-skeleton-loader style="width:360px; height:22px; display:block;"></ngx-skeleton-loader>
            </span>
          </span>
        </div>

        <div class="btn-wrap flex-row gap-x-2">
          <ngx-skeleton-loader style="width:96px; height:36px; border-radius:6px;"></ngx-skeleton-loader>
          <ngx-skeleton-loader style="width:96px; height:36px; border-radius:6px;"></ngx-skeleton-loader>
        </div>
      </div>

      <div class="details-view-row-desc" style="display: flex; justify-content: space-between; align-items: center;">
        <ngx-skeleton-loader style="width:320px; height:16px;"></ngx-skeleton-loader>
        <ngx-skeleton-loader style="width:80px; height:18px;"></ngx-skeleton-loader>
      </div>
    </div>
    }

  </div>

  <div class="muv-cc-missing" *ngIf="dataLoaded && trial.muvEnabled && !trial.muvHasCc">
    This trial has Muv enabled, but no CC details have been added. Please contact Tappable to rectify ASAP.
  </div>

  <div class="tabs-wrap">
    <app-mobile-tabs #mobileTabs (onSelected)="onSelectTab($event)" selectedValue="sites">
      <ul>
        <li><a class="selected" (click)="mobileTabs.onSelectItem('sites', $event)">Sites</a>
        <li><a (click)="mobileTabs.onSelectItem('patients', $event)"
            *ngIf="authService.hasPermission(Permissions.TrialPatientsRead)">Patients</a></li>
        <li><a (click)="mobileTabs.onSelectItem('policies', $event)">Policies</a></li>
        <li><a (click)="mobileTabs.onSelectItem('contacts', $event)">Support Contacts</a></li>
        <li><a (click)="mobileTabs.onSelectItem('change-log', $event)"
            *ngIf="authService.hasPermission(Permissions.TrialChangeLogRead)">Change Log</a></li>
        <li><a (click)="mobileTabs.onSelectItem('change-log', $event)"
            *ngIf="authService.hasPermission(Permissions.TrialPaymentsRead)">Payments</a></li>
        <li><a (click)="mobileTabs.onSelectItem('bookings', $event)"
            *ngIf="dataLoaded && trial.bookingEnabled">Bookings</a></li>
        <li
          *ngIf="authService.hasRole(roleNames.ProductAdministrator) || authService.hasRole(roleNames.SystemAdministrator)">
          <a (click)="mobileTabs.onSelectItem('CMS Users', $event)">CMS Users</a>
        </li>
        <li><a (click)="mobileTabs.onSelectItem('trial-integration', $event)">Integration</a></li>
      </ul>
    </app-mobile-tabs>


    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': selectedTab == 'sites'}" data-toggle="tab" id="trial-sites-anchor"
          (click)="onSelectTab('sites')">Sites</a>
      </li>
      <li class="nav-item" *ngIf="authService.hasPermission(Permissions.TrialPatientsRead)">
        <a class="nav-link" [ngClass]="{'active': selectedTab == 'patients'}" data-toggle="tab"
          id="trial-patients-anchor" (click)="onSelectTab('patients')">Patients</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': selectedTab == 'policies'}" data-toggle="tab"
          id="trial-policies-anchor" (click)="onSelectTab('policies')">Policies</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': selectedTab == 'support'}" data-toggle="tab" id="trial-support-anchor"
          (click)="onSelectTab('support')">Support</a>
      </li>
      <li class="nav-item" *ngIf="authService.hasPermission(Permissions.TrialChangeLogRead)">
        <a class="nav-link" [ngClass]="{'active': selectedTab == 'change-log'}" data-toggle="tab"
          id="trial-change-log-anchor" (click)="onSelectTab('change-log')">Change Log</a>
      </li>
      <li class="nav-item" *ngIf="dataLoaded && trialInfoTabEnabled">
        <a class="nav-link" [ngClass]="{'active': selectedTab == 'trial-info'}" data-toggle="tab" id="trial-info-anchor"
          (click)="onSelectTab('trial-info')">Trial Info</a>
      </li>
      <li class="nav-item" *ngIf="authService.hasPermission(Permissions.TrialPaymentsRead)">
        <a class="nav-link" [ngClass]="{'active': selectedTab == 'payments'}" data-toggle="tab" id="trial-payments"
          (click)="onSelectTab('payments')">Payments</a>
      </li>
      <li class="nav-item" *ngIf="authService.hasPermission(Permissions.TrialAutoStipend)">
        <a class="nav-link" [ngClass]="{'active': selectedTab == 'visit-schedule'}" data-toggle="tab"
          id="trial-visit-schedule" (click)="onSelectTab('visit-schedule')">Visit Schedule</a>
      </li>
      <li class="nav-item"
        *ngIf="dataLoaded && trial.bookingEnabled && authService.hasPermission(Permissions.TrialBooking)">
        <a class="nav-link" [ngClass]="{'active': selectedTab == 'bookings'}" data-toggle="tab"
          id="trial-bookings-anchor" (click)="onSelectTab('bookings')">Bookings</a>
      </li>
      <li class="nav-item" *ngIf="authService.hasPermission(Permissions.TrialCmsUsers)">
        <a class="nav-link" [ngClass]="{'active': selectedTab == 'cms-users'}" data-toggle="tab" id="cms-users-anchor"
          (click)="onSelectTab('cms-users')">CMS Users</a>
      </li>
      <li class="nav-item" *ngIf="dataLoaded && trial.apiEnabled">
        <a class="nav-link" [ngClass]="{'active': selectedTab == 'trial-integration'}" data-toggle="tab"
          id="integration-anchor" (click)="onSelectTab('trial-integration')">Integration</a>
      </li>
      @if (dataLoaded && trial.genericDiaryEnabled) {
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': selectedTab == 'trial-generic-diary'}" data-toggle="tab"
          id="trial-generic-diary" (click)="onSelectTab('trial-generic-diary')">E-Diary</a>
      </li>
      }
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': selectedTab == 'trial-notifications'}" data-toggle="tab"
          id="trial-notifications" (click)="onSelectTab('trial-notifications')">Notifications</a>
      </li>
      <li class="nav-item" *ngIf="dataLoaded && trial.faqsEnabled">
        <a class="nav-link" [ngClass]="{'active': selectedTab == 'trial-faqs'}" data-toggle="tab" id="trial-faqs"
          (click)="onSelectTab('trial-faqs')">FAQs</a>
      </li>
    </ul>
  </div>

  <div class="tab-content" id="details-view-tab-content">

    @if (selectedTab === 'sites') {
    <app-trial-sites [trialId]="trial.id" [apiEnabled]="trial.apiEnabled"></app-trial-sites>
    }

    @if (selectedTab === 'patients') {
    <app-trial-patients [apiEnabled]="trial.apiEnabled"></app-trial-patients>
    }

    @if (selectedTab === 'policies') {
    <app-trial-policies [trial]="trial"></app-trial-policies>
    }

    @if (selectedTab === 'change-log') {
    <app-trial-change-log [trialId]="trial.id"></app-trial-change-log>
    }

    @if (selectedTab === 'support') {
    <app-trial-support #supportComponent (contactsHasChanges)="supportContactsHasChanged = $event"
      [trial]="trial"></app-trial-support>
    }

    @if (selectedTab === 'trial-info') {
    <app-trial-information [trialId]="trial.id"></app-trial-information>
    }

    @if (selectedTab === 'payments') {
    <app-trial-payments [trialId]="trial.id" [virtualCardInAppEnabled]="trial.virtualCardInAppEnabled" [nmibleBankInAppEnabled]="trial.nmibleBankInAppEnabled"></app-trial-payments>
    }

    @if (selectedTab === 'visit-schedule') {
    <app-trial-visit-schedule [trialId]="trial.id" [diaryEnabled]="trial.diaryEnabled"
      [genericDiaryEnabled]="trial.genericDiaryEnabled" [trialBrandName]="trial.brandName"></app-trial-visit-schedule>
    }

    @if (selectedTab === 'bookings') {
    <app-trial-bookings [trialId]="trial.id"></app-trial-bookings>
    }

    @if (selectedTab === 'cms-users') {
    <app-trial-users [trialId]="trial.id" [trialUsers]="trial.trialUsers" (refreshTrial)="loadTrial(trial.id)"
      (userRoleChanged)="onUserRoleChanged($event)"></app-trial-users>
    }

    @if (selectedTab === 'trial-integration') {
    <app-trial-integration [apiConsumers]="trial.apiConsumers"></app-trial-integration>
    }

    @if (trial.genericDiaryEnabled && selectedTab === 'trial-generic-diary') {
    <app-trial-diaries [trialId]="trial.id"></app-trial-diaries>
    }

    @if (selectedTab == 'trial-notifications') {
    <app-trial-notifications [trialId]="trial.id" [diaryEnabled]="trial.genericDiaryEnabled"></app-trial-notifications>
    }

    @if (trial.faqsEnabled && selectedTab === 'trial-faqs') {
    <app-trial-faqs [trial]="trial"></app-trial-faqs>
    }
  </div>

</div>

<!-- Start: Contact changes modal -->
<app-modal *ngIf="dataLoaded" #contactModal>
  <div class="modal-header">
    <h2 class="modal-title">Unsaved Changes</h2>
  </div>
  <div class="modal-body">
    <p>You have unsaved support contact changes, are you sure you want to continue and lose your changes</p>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <a (click)="contactModal.hide()" class="btn btn-secondary" data-dismiss="modal">No, go back</a>
      </div>

      <div class="col-6">
        <a (click)="onConfirmSelectTab(preSelectedTab)" class="btn btn-primary">Yes, continue</a>
      </div>
    </div>
  </div>
</app-modal>
<!-- End: Contact modal changes -->

<!-- Start: Export patient change log modal -->
<app-modal *ngIf="dataLoaded" #exportTripsModal>
  <div class="modal-header">
    <h2 class="modal-title">Export</h2>
  </div>
  <div class="modal-body">
    <form class="modal-form-full-width" [formGroup]="exportForm">
      <ng-container *ngIf="exportForm.get('allData').value === false">
        <div class="form-group">
          <label>Start Date</label>
          <input type="text" #dateFrom class="date" data-toggle="datepicker" formControlName="dateFrom">
        </div>

        <div class="form-group">
          <label>End Date</label>
          <input type="text" #dateTo class="date" data-toggle="datepicker" formControlName="dateTo">
        </div>
      </ng-container>

      <div class="form-group" *ngIf="dataLoaded && (trial.diaryEnabled || trial.genericDiaryEnabled)">
        <label>What to Export</label>
        <mat-select formControlName="type" placeholder="Select...">
          <mat-option *ngFor="let option of exportOptions" [value]="option.value">{{ option.text }}</mat-option>
        </mat-select>
      </div>

      <ng-container *ngIf="dataLoaded">
        <div
          [class.visibility-hidden]="this.exportForm.get('type').value !== 'diary' && this.exportForm.get('type').value !== 'generic-diary'">
          @if (exportForm.get('type').value === 'generic-diary') {
          <div class="form-group">
            <label>E-Diary Form</label>
            <mat-select formControlName="diaryFormId" placeholder="Select diary form..." hideSingleSelectionIndicator>
              <mat-option *ngFor="let form of diaryForms" [value]="form.id">{{ form.name }}</mat-option>
            </mat-select>
          </div>
          }

          <div class="form-group" [class.visibility-hidden]="exportForm.get('allSites').value === true">
            <label>Site</label>
            <app-site-dropdown formControlName="site" [trialId]="trial.id" [trialIdRequired]="true"
              [assignedOnly]="true" [unassignedOnly]="false" [approvedOnly]="true" />
          </div>

          <div class="form-group">
            <label class="checkbox">
              <input formControlName="allSites" id="all-sites" type="checkbox" value="true">
              <span></span>
            </label>
            <label class="checkbox-label" for="all-sites">All sites</label>
          </div>

          <div class="form-group">
            <label class="checkbox">
              <input formControlName="allData" id="all-data" type="checkbox" value="true">
              <span></span>
            </label>
            <label class="checkbox-label" for="all-data">All available data (ignore date range)</label>
          </div>
        </div>
      </ng-container>
    </form>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <a (click)="exportTripsModal.hide()" class="btn btn-secondary" data-dismiss="modal">Cancel</a>
      </div>

      <div class="col-6">
        <a (click)="onExportChangeLog()" class="btn btn-primary" (mousemove)="updateExportFormValues()">
          <span *ngIf="exportIsProcessing">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span class="sr-only">Loading...</span>
          </span>
          <span *ngIf="!exportIsProcessing">Export</span>
        </a>
      </div>
    </div>
  </div>
</app-modal>
<!-- End: Export patient change log modal -->
